var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTuvalu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.874C32 25.7105 24.8365 32.874 16.0001 32.874C7.1635 32.874 0 25.7105 0 16.874C0 16.8778 16.0001 0.875773 16.0001 0.874023C24.8365 0.874023 32 8.03752 32 16.874Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65259 16.874H13.049L8.34821 11.3088L7.65259 13.3957V16.874Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 13.923L10.4348 8.52661H16L16.0001 13.923Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9568 16.8736H15.9996C15.9996 16.8592 15.9996 16.8452 15.9996 16.8308C15.9853 16.8451 15.9711 16.8594 15.9568 16.8736Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 9.22184C16.0001 6.40652 16.0001 4.56177 16.0001 0.874023H15.9974C7.162 0.875523 0 8.03834 0 16.874H8.34787V12.1733L13.0486 16.874H15.9573C15.9716 16.8598 15.9858 16.8455 16.0001 16.8312C16.0001 15.7533 16.0001 14.7915 16.0001 13.9226L11.2992 9.22184H16.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09515 2.96131C5.59271 4.38625 3.51234 6.46662 2.0874 8.96906V16.8744H6.26134V7.13537V7.13525H16.0005C16.0005 5.81881 16.0005 4.56469 16.0005 2.96131H8.09515Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0008 14.907L10.3161 9.22243H8.34863V9.22255L16.0007 16.8746H16.0008C16.0008 16.8746 16.0008 15.5179 16.0008 14.907V14.907Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4629 27.3088L17.8083 28.3717H18.9258L18.0217 29.0285L18.3671 30.0914L17.4629 29.4345L16.5588 30.0914L16.9042 29.0285L16 28.3717H17.1175L17.4629 27.3088Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3628 20.352L26.7082 21.4148H27.8257L26.9217 22.0718L27.2671 23.1346L26.3628 22.4778L25.4588 23.1346L25.8042 22.0718L24.8999 21.4148H26.0175L26.3628 20.352Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5935 9.91725L28.9389 10.9801H30.0564L29.1524 11.637L29.4977 12.6998L28.5935 12.043L27.6894 12.6998L28.0348 11.637L27.1306 10.9801H28.2482L28.5935 9.91725Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.146 17.5698L29.4914 18.6327H30.6089L29.7049 19.2896L30.0502 20.3524L29.146 19.6956L28.242 20.3524L28.5874 19.2896L27.6831 18.6327H28.8007L29.146 17.5698Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.065 24.8084L20.0609 25.3159L20.8511 24.5257L20.6764 25.6294L21.672 26.1368L20.5682 26.3116L20.3934 27.4154L19.8861 26.4196L18.7822 26.5946L19.5724 25.8044L19.065 24.8084Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.065 20.6348L20.0609 21.1421L20.8511 20.352L20.6764 21.4557L21.672 21.963L20.5682 22.1379L20.3934 23.2417L19.8861 22.246L18.7822 22.4208L19.5724 21.6306L19.065 20.6348Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5437 23.3106L23.5397 23.818L24.3299 23.0278L24.1551 24.1315L25.1508 24.6389L24.0469 24.8137L23.8721 25.9176L23.3649 24.9217L22.261 25.0967L23.0512 24.3065L22.5437 23.3106Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5437 14.3737L23.5397 14.8811L24.3299 14.0909L24.1551 15.1947L25.1508 15.702L24.0469 15.8768L23.8721 16.9807L23.3649 15.9849L22.261 16.1598L23.0512 15.3696L22.5437 14.3737Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9143 14.2665L26.9103 14.7739L27.7005 13.9837L27.5257 15.0874L28.5214 15.5947L27.4175 15.7696L27.2427 16.8734L26.7355 15.8777L25.6316 16.0525L26.4218 15.2624L25.9143 14.2665Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.874023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuvalu);
export default __webpack_public_path__ + "static/media/tuvalu.e040395d.svg";
export { ForwardRef as ReactComponent };